module.exports = __webpack_public_path__ + "img/about-page-icon-bots.cfabefae.svg";